<template>
  <div>
    <hr />

    <DataTable
      :data="medinters"
      :columns="columnas"
      idField="idMedInter"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarVer="false"
      :mostrarEditar="true"
      :mostrarEliminar="true"
      mensajeVacio="No hay medicamentos registrados."
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idMedInter)"
      @delete="row => deleteInterMed(row.idMedInter)"
    />

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="modalMedLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalMedLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form @submit.prevent>
            <div class="modal-body">

              <!-- Elemento / Medicamento -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label">Elemento</label>
                  </div>
                  <div class="col-10">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="searchTextElem"
                        @input="filterElementos"
                        @keyup.enter="toggleDropdown"
                        placeholder="Buscar elemento..."
                      />
                      <button
                        class="btn btn-outline-secondary dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        ref="dropdownButton"
                      >
                        <span class="material-symbols-outlined" style="font-size:16px">search</span>
                      </button>
                      <ul
                        class="dropdown-menu dropdown-menu-end shadow"
                        style="max-height: 250px; overflow-y: auto; width: 100%;"
                        ref="dropdownMenu"
                      >
                        <li v-for="elemento in filteredElementos" :key="elemento.idElemento">
                          
                            class="dropdown-item text-truncate"
                            href="#"
                            @click.prevent="selectElemento(elemento)"
                            :title="elemento.codigo + ' - ' + elemento.nombre"
                          >
                            {{ elemento.codigo }} - {{ elemento.nombre }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Dosis -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label">Dosis</label>
                  </div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoMedInter.idDosis">
                      <option v-for="dosis in dosiss" :value="dosis.idDosis" :key="dosis.idDosis">
                        {{ dosis.dosisNombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Frecuencia -->
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2">
                    <label class="form-label">Frecuencia</label>
                  </div>
                  <div class="col-4">
                    <select class="form-select" v-model="datoMedInter.idFrecuencia">
                      <option v-for="frecuencia in frecuencias" :value="frecuencia.idFrecuencia" :key="frecuencia.idFrecuencia">
                        {{ frecuencia.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-primary btn-fixed-width" @click="asignarFrecuencia(1)">qd</button>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-primary btn-fixed-width" @click="asignarFrecuencia(2)">bid</button>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-primary btn-fixed-width" @click="asignarFrecuencia(3)">tid</button>
                  </div>
                </div>
              </div>

              <!-- Duración -->
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2">
                    <label class="form-label">Duración</label>
                  </div>
                  <div class="col-4">
                    <input
                      type="number"
                      class="form-control"
                      v-model="datoMedInter.duracion"
                      min="1"
                    />
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-primary btn-fixed-width" @click="asignarDuracion(3)">3</button>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-primary btn-fixed-width" @click="asignarDuracion(7)">7</button>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-primary btn-fixed-width" @click="asignarDuracion(15)">15</button>
                  </div>
                </div>
              </div>

              <!-- Indicación -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label">Indicación</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoMedInter.indicacion"
                      style="text-transform: uppercase"
                    />
                  </div>
                </div>
              </div>

              <!-- Observación -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label">Observación</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoMedInter.observacion"
                      style="text-transform: uppercase"
                    />
                  </div>
                </div>
              </div>

            </div>
          </form>
          <div class="modal-footer">
            <button
              v-if="btnCrear"
              type="button"
              class="btn btn-success d-flex align-items-center gap-1"
              @click.prevent="guardarInterMed"
            >
              <span class="material-symbols-outlined">save</span> Guardar
            </button>
            <button
              v-if="btnEditar"
              type="button"
              class="btn btn-success d-flex align-items-center gap-1"
              @click.prevent="guardarEditInterMed"
            >
              <span class="material-symbols-outlined">update</span> Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js'
import DataTable from '@/components/DataTable.vue'
import api from '@/services/api'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import swal from 'sweetalert'

export default {
  components: { DataTable },

  props: {
    p_idInformeInter: { type: Number, required: true },
  },

  data() {
    return {
      medinters:         [],
      datoMedInter:      {},
      titulo:            '',
      btnCrear:          false,
      btnEditar:         false,
      modalWindow:       true,
      elementos:         [],
      filteredElementos: [],
      frecuencias:       [],
      dosiss:            [],
      searchTextElem:    '',

      columnas: [
        { field: 'elementoNombre',   label: 'Medicamento' },
        { field: 'duracion',         label: 'Duración' },
        { field: 'dosisNombre',      label: 'Dosis' },
        { field: 'frecuenciaNombre', label: 'Frecuencia' },
        { field: 'indicacion',       label: 'Indicación' },
      ],
    }
  },

  watch: {
    'datoMedInter.idElemento'(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchDosiss(newVal)
    },
  },

  mounted() {
    this.getData()
    this.fetchElementos()
    this.fetchFrecuencias()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    getData() {
      api.get('/vwmedinters/idinformeinter/' + this.p_idInformeInter)
        .then(response => { this.medinters = response.data.reverse() })
        .catch(error => console.error('Error al obtener medicamentos:', error))
    },

    validarFormLocal() {
      const fields = ['idElemento', 'idFrecuencia', 'idDosis', 'duracion', 'indicacion']
      return validarForm(this.datoMedInter, fields, fields)
    },

    async guardarInterMed() {
      if (this.validarFormLocal() !== 1) return
      try {
        this.datoMedInter.idInformeInter = this.p_idInformeInter
        await api.post('/medinters', this.datoMedInter)
        closeModal('ventanaModal')
        swal('Correcto!', 'Medicamento registrado exitosamente!', 'success')
        this.getData()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
      }
    },

    async guardarEditInterMed() {
      if (this.validarFormLocal() !== 1) return
      try {
        await api.post('/medinters', this.datoMedInter)
        closeModal('ventanaModal')
        swal('Correcto!', 'Medicamento actualizado exitosamente!', 'success')
        this.getData()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        Object.values(error.response?.data?.errors ?? {}).forEach(e => swal(String(e)))
      }
    },

    abrirModalCrear() {
      this.modalWindow    = true
      this.datoMedInter   = {}
      this.searchTextElem = ''
      this.titulo         = 'Registrar Medicamento'
      this.btnCrear       = true
      this.btnEditar      = false
      openModal('ventanaModal')
    },

    abrirModalEditar(idMedInter) {
      this.modalWindow = true
      if (idMedInter) {
        api.get('/vwmedinters/' + idMedInter).then(resp => {
          this.datoMedInter   = resp.data
          this.searchTextElem = resp.data.elementoNombre
        })
      }
      this.titulo    = 'Editar Medicamento'
      this.btnCrear  = false
      this.btnEditar = true
      openModal('ventanaModal')
    },

    async deleteInterMed(idMedInter) {
      try {
        await api.delete('/medinters/' + idMedInter)
        this.getData()
      } catch (error) {
        swal('Error!', 'No se pudo eliminar el registro.', 'error')
      }
    },

    fetchElementos() {
      api.get('/vwelementos')
        .then(response => {
          this.elementos         = response.data
          this.filteredElementos = response.data
        })
        .catch(error => console.error('Error fetching elementos:', error))
    },

    filterElementos() {
      this.filteredElementos = this.elementos.filter(e =>
        e.nombre.toLowerCase().includes(this.searchTextElem.toLowerCase())
      )
    },

    selectElemento(elemento) {
      this.datoMedInter.idElemento = elemento.idElemento
      this.searchTextElem = `${elemento.codigo} - ${elemento.nombre}`
    },

    fetchFrecuencias() {
      api.get('/vwfrecuencias')
        .then(response => { this.frecuencias = response.data })
        .catch(error => console.error('Error fetching frecuencias:', error))
    },

    async fetchDosiss(idElemento) {
      try {
        const { data } = await api.get('/vwdosismeds/idelemento/' + idElemento)
        if (data.length > 0) {
          this.dosiss = data.map(d => ({ idDosis: d.idDosis, dosisNombre: d.dosisNombre }))
        } else {
          await this.fetchDosisGeneral()
        }
      } catch {
        await this.fetchDosisGeneral()
      }
    },

    async fetchDosisGeneral() {
      try {
        const { data } = await api.get('/vwdosiss')
        this.dosiss = data.map(d => ({ idDosis: d.idDosis, dosisNombre: d.nombre }))
      } catch (error) {
        console.error('Error fetching dosis general:', error)
      }
    },

    asignarFrecuencia(idFrecuencia) {
      this.datoMedInter.idFrecuencia = idFrecuencia
    },

    asignarDuracion(duracion) {
      this.datoMedInter.duracion = duracion
      const elemento   = this.elementos.find(e => e.idElemento === this.datoMedInter.idElemento)
      const frecuencia = this.frecuencias.find(f => f.idFrecuencia === this.datoMedInter.idFrecuencia)
      this.datoMedInter.indicacion =
        `${elemento?.nombre ?? ''} ${frecuencia?.descripcion ?? ''} por ${duracion} días`
    },

    toggleDropdown() {
      this.$refs.dropdownButton.click()
    },
  },
}
</script>

<style scoped>
.btn-fixed-width {
  width: 100px;
}
</style>